import { render, staticRenderFns } from "./sub-task-table.vue?vue&type=template&id=150d3c50&"
import script from "./sub-task-table.vue?vue&type=script&lang=js&"
export * from "./sub-task-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports